<template>
  <v-container class="grey lighten-5">
    <h2>Manuelles Hochladen von Zertifikaten</h2>
    <br/>
    <v-text-field v-model="certificateId" label="zertifikatsId (ohne .pdf)"/>
    <v-text-field v-model="name" label="Name des Nutzers"/>
    <v-text-field v-model="courseName" label="Kursname"/>
    <v-text-field
        v-model="date"
        label="Datum"
        persistent-hint
        prepend-icon="mdi-calendar"
        hint="[DD.MM.YYYY]"
    />
    <v-file-input
        truncate-length="24"
        accept="application/pdf"
        @change="fileSelected"
        label="ZIP Datei auswählen"
    ></v-file-input>
    <v-btn class="ma-1" color="info" :loading="loading"
           :disabled="loading || file===null || name.length===0 || certificateId.length===0 || !validDate"
           @click="uploadCertificates">
      Zertifikat hochladen
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>

    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top app>{{ errorText }}</v-snackbar>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>{{ successText }}</v-snackbar>

  </v-container>

</template>

<script>


import moment from "moment/moment";

export default {
  name: "SuperAdminCertUpload",
  data: () => ({
    packages: [],
    loading: false,
    file: null,
    name: "",
    courseName: "",
    date: "",
    certificateId: "",
    error: false,
    success: false,
    progress: 0,
    errorText: "",
    successText: "Erfolgreich hochgeladen",
    standardHeaders: [
      {
        text: "Titel",
        value: "title",
      },
      {
        text: "Ansehen", value: "open",
        sortable: false,
      },
      {
        text: "Löschen", value: "delete",
        sortable: false,
      },
    ]
  }),
  computed: {
    validDate() {
      let dateMoment = moment(this.date, "DD.MM.YYYY", true)
      return dateMoment.isValid() && this.date.length > 0;
    }
  },
  methods: {
    uploadCertificates() {
      if (this.file != null && this.name.length > 0 && this.certificateId.length > 0) {
        this.loading = true;
        this.$httpLicenseApi.uploadRaw(this.file, this.certificateId, this.name, this.courseName, moment(this.date, "DD.MM.YYYY", true), () => {
          this.loading = false;
          this.successText = "Erfolgreich hochgeladen"
          this.success = true;
          setTimeout(() => this.success = false, 3000);
          this.zip = null;
        }, () => {
          this.loading = false;
          this.errorText = "Fehler beim Hochladen der Datei."
          this.error = true;
          setTimeout(() => this.error = false, 5000);
        })
      }
    },
    fileSelected(file) {
      this.file = file;
    },
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
